{
	"main": {
		"titleMotorna": "Motorna",
		"titleJadralna": "Jadralna",
		"nazaj": "Nazaj"
	},
	"nav": {
		"jadralna": "Obračun jadralnih",
		"motorna": "Obračun Motornih"
	},
	"labels": {
		"datumOd": "Datum OD :",
		"datumDo": "DAtum DO :",
		"klubL": "Izberi klub letala:",
		"klubP": "Izberi klub pilota:",
		"namen": "Izberi namen:",
		"naloga": "Izberi nalogo:",
		"pilot": "Izberi pilota:",
		"reg": "Izberi reg. letala:",
		"stPristankov": "Št. pristankov: ",
		"stLetov": "Št. letov: ",
		"casVZraku": "Čas v zraku: "

	},
	"data": {
		"title": "Podatki",
		"stPristankov": "Št. pristankov:",
		"stLetov": "Št. letov:",
		"casVZraku": "Trajanje:"
	},
	"buttons": {
		"csv": "Izvoz v CSV ",
		"natisni": "Natisni ",
		"poslji": "Pošlji ",
		"brisiIzbiro": "Pobriši izbiro",
		"brisiZapis": "Izbriši zapis"
	},
	"table": {
		"reg": "REG",
		"vzlet": "VZLET",
		"pilot": "PILOT",
		"trajanje": "TRAJANJE",
		"naloga": "NALOGA",
		"datum": "DATUM",
		"pristanek": "PRISTANEK",
		"titleU": "ULTRALIGHT LETI"
	},
	"modal": {
		"reg": "registracija: ",
		"vlecno": "vlečno letalo: ",
		"pilot": "pilot: ",
		"instruktor": "inštruktor: ",
		"namen": "namen: ",
		"naloga": "naloga: ",
		"krajV": "kraj vzleta: ",
		"krajP": "kraj pristanka: ",
		"casV": "čas vzleta: ",
		"casP": "čas pristanka: ",
		"casL": "čas letenja: ",
		"stPristankov": "št. pristankov: ",
		"ifr": "ifr: ",
		"nocno": "nocno: ",
		"vizuelno": "vizuelno: ",
		"opomba": "opomba: ",
		"datumL": "datum letenja: ",
		"datumV": "datum vnosa: "
	}
}